import { guidGenerator } from 'src/features/Map/utils/functions'
import { Hours } from 'src/types/schema/graphql'
import { parseBusinessHours } from 'src/util/helpers'

interface IFormattedRow {
    dayObj: Hours
}
export const FormattedRow: React.FC<IFormattedRow> = ({ dayObj }) => {
    const arr: { open: string; close: string; id: string }[] = []
    dayObj.hours.forEach((_, i) => {
        const parsedHours: { open: string; close: string; id: string } = {
            ...parseBusinessHours([dayObj])[0].hours[i],
            id: guidGenerator(),
        }
        arr.push(parsedHours)
    })
    const hoursRange = arr.map((item) => (
        <p key={item?.id}>
            {item?.open} - {item?.close}
        </p>
    ))
    return <div className='flex flex-col items-end space-x-2'>{hoursRange}</div>
}
